import { apiSlice } from '..';
import { ClientConfiguration, MuxConfigurationResponse } from '../generated';

const clientConfigSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getClientConfig: builder.query<ClientConfiguration, void>({
            query: () => '/configuration'
        }),
        getMuxConfig: builder.query<MuxConfigurationResponse, void>({
            query: () => '/configuration/mux'
        }),
    })
});

export const { useGetClientConfigQuery, useGetMuxConfigQuery } = clientConfigSlice;
export default clientConfigSlice;